export default __webpack_public_path__ + "static/media/front_b.511c2bd7.jpg";